import { useRef } from 'react';

interface IProps {
    elementName: string,
    valid: boolean,
    disable: boolean,
    accept?: string,
    bsSize?: string,
    width?: number | string,
    onSelectFile: (file: File) => void,
}

const UploadFile = (props: IProps) => {
    const fileInput = useRef<HTMLInputElement>();

    const handleFileChange = (e: React.FormEvent<HTMLInputElement>) => {
        props.onSelectFile(e.currentTarget.files[0]);
    };

    const bsSize = props.bsSize ? props.bsSize : 'btn-xs';

    return (
        <>
            {!props.disable && (
                <>
                    <input type='file' id={props.elementName} ref={fileInput} accept={props.accept} style={{ opacity: 0, position: 'absolute', pointerEvents: 'none', width: 1, height: 1 }} onChange={handleFileChange} />
                    <label className={'btn btn-primary ' + bsSize} style={{ borderWidth: props.valid ? 1 : 2, borderColor: props.valid ? '#2e6da4' : 'red', width: props.width }} htmlFor={props.elementName}>Select File</label>
                </>
            )}
        </>
    );
}

export default UploadFile;